// Debug utility for authorization issues
export const debugAuthState = () => {
  const authState = {
    localStorage: {
      isUserAuthorized: localStorage.getItem('isUserAuthorized'),
      adminUsers: localStorage.getItem('adminUsers'),
    },
    sessionStorage: {
      wasAuthorized: sessionStorage.getItem('wasAuthorized'),
    },
    currentUrl: window.location.href,
    timestamp: new Date().toISOString()
  };
  
  console.log('🔍 Auth Debug State:', authState);
  return authState;
};

export const clearAuthCache = () => {
  console.log('🧹 Clearing auth cache...');
  
  // Clear localStorage auth data
  localStorage.removeItem('isUserAuthorized');
  localStorage.removeItem('adminUsers');
  
  // Clear sessionStorage auth data
  sessionStorage.removeItem('wasAuthorized');
  
  // Clear any other auth-related data
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith('auth_') || key.startsWith('user_')) {
      localStorage.removeItem(key);
    }
  });
  
  console.log('✅ Auth cache cleared');
};

export const forceAuthCheck = async () => {
  console.log('🔄 Forcing auth check...');
  
  // Clear cache first
  clearAuthCache();
  
  // Reload page to trigger fresh auth check
  window.location.reload();
};

// Add to window for easy debugging in console
if (typeof window !== 'undefined') {
  window.debugAuth = debugAuthState;
  window.clearAuthCache = clearAuthCache;
  window.forceAuthCheck = forceAuthCheck;
}